import { axiosPost } from '../utils/api';

export const askUnderstand = (payload, config = {}) => axiosPost('/understand/answer', payload, config);
